<template>
    <v-card>
        <v-container fluid class="pa-0">
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="isLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :mobile-breakpoint="0"
                        name="ReportingProcessingReportsTable"
                        @pagination="updatePagination"
                    >
                        <template #item.objectNumber="{item}">
                            {{ item.objectNumber }}
                        </template>
                        <template #item.machineSymbol="{item}">
                            {{ item.machineSymbol }}
                        </template>
                        <template #item.processName="{item}">
                            {{ item.processName }}
                        </template>
                        <template #item.plateNumber="{item}">
                            {{ item.plateNumberRead }}
                        </template>
                        <template #item.reportAmount="{item}">
                            {{ parseEmptyValue(item.reportAmount) }}
                        </template>
                        <template #item.machineStuffAmount="{item}">
                            {{ item.machineStuffAmount }}
                        </template>
                        <template #item.statusId="{item}">
                            <span
                                :class="{
                                    'success--text': item.statusId === 99,
                                    'error--text': item.statusId === 1
                                }"
                            >
                                {{ statusName(item.statusId) }}
                            </span>
                        </template>
                        <template #item.start="{item}">
                            {{ item.makeReadyStart ? formatDate(item.makeReadyStart) : formatDate(item.start) }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Szczegóły raportu"
                                            v-on="on"
                                            @click="openReport(item.id)"
                                        >
                                            <v-icon color="blue">
                                                mdi-ballot
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Szczegóły raportu</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'
import parse from '@/mixins/parse'
import tooltipDelay from '@/mixins/tooltip'
import pagination from '@/mixins/dataTablePagination'


export default {
    name: 'ReportingProcessingReportsTable',
    mixins: [
        dateFormatter,
        parse,
        tooltipDelay,
        pagination,
    ],
    props: {
        items: {
            type: Array,
            required: true
        },
        isLoading: {
            type: Boolean,
        },
        headers: {
            type: Array,
            required: true
        },
    },
    computed: {
        statusNames() {
            return this.$store.state.reports.reports.statusNames
        },
    },
    mounted() {
        if (!this.statusNames) {
            this.$store.dispatch('reports/getStatusNames')
        }
    },
    methods: {
        updatePagination(pagination) {
            this.$emit('update-pagination', pagination)
        },
        openReport(id) {
            this.$emit('open-report', id)
        },
        statusName(statusId) {
            return this.statusNames ? this.statusNames.find(item => item.id == statusId).name : statusId
        },
    }
}
</script>
